export default {
  label: {
    height: 56,
    display: 'flex' as 'flex',
    alignItems: 'flex-start' as 'flex-start',
    justifyContent: 'center' as 'center',
    flexDirection: 'column' as 'column',
  },
};
